"use strict";
/*
Apparently the npm 'events' library doesn't actually implement a separate
once function like the Node package does. See issue:
https://github.com/Gozala/events/issues/63#issuecomment-487399536

This code is taken directly from a Node PR, for the Node version that matches
the code in the npm 'events' package:
https://github.com/mcollina/node/blob/30b99feb3a05b87115246382628ad10535c00be1/lib/events.js
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.once = function (emitter, name) {
    return new Promise(function (resolve, reject) {
        var eventListener = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (errorListener !== undefined) {
                emitter.removeListener('error', errorListener);
            }
            resolve(args);
        };
        var errorListener;
        // Adding an error listener is not optional because
        // if an error is thrown on an event emitter we cannot
        // guarantee that the actual event we are waiting will
        // be fired. The result could be a silent way to create
        // memory or file descriptor leaks, which is something
        // we should avoid.
        if (name !== 'error') {
            errorListener = function (err) {
                emitter.removeListener(name, eventListener);
                reject(err);
            };
            emitter.once('error', errorListener);
        }
        emitter.once(name, eventListener);
    });
};
